<template>
  <main>
    <LandingPage />
  </main>
</template>

<script setup lang="ts">
import { useDialogsStore, Dialogs } from "~/stores/dialogStore";
import LandingPage from "~/features/landing-page";

const route = useRoute();
const router = useRouter();
const { t } = useI18n();
const localePath = useLocalePath();
const config = useRuntimeConfig();

const siteUrl = (config.public.siteUrl as string) || "";

useSeoMeta({
  title: () => t("page_data.index.seo_title"),
  description: () => t("page_data.index.seo_description"),
  ogTitle: () => t("page_data.index.seo_title"),
  ogDescription: () => t("page_data.index.seo_description"),
  ogUrl: () => (siteUrl ? `${siteUrl}${route.path}` : undefined),
  ogImage: () => (siteUrl ? `${siteUrl}/home/gfs-group-tradelines-for-sale-800w.webp` : undefined),
  ogImageAlt: () => t("index_page.image_alt_content"),
});
useHead(() => ({
  meta: [{ name: "keywords", content: t("page_data.index.seo_keywords") }],
  // LCP: preload smallest matching hero so LCP wins.
  link: [
    { rel: "preload", href: "/home/gfs-group-tradelines-for-sale-320w.webp", as: "image", type: "image/webp", fetchPriority: "high", media: "(max-width: 400px)" },
    { rel: "preload", href: "/home/gfs-group-tradelines-for-sale-400w.webp", as: "image", type: "image/webp", fetchPriority: "high", media: "(min-width: 401px) and (max-width: 480px)" },
    { rel: "preload", href: "/home/gfs-group-tradelines-for-sale-568w.webp", as: "image", type: "image/webp", fetchPriority: "high", media: "(min-width: 481px) and (max-width: 768px)" },
    { rel: "preload", href: "/home/gfs-group-tradelines-for-sale-800w.webp", as: "image", type: "image/webp", fetchPriority: "high", media: "(min-width: 769px)" },
  ],
}));

onMounted(() => {
  if (route.query?.loginModal) {
    const dialogs = useDialogsStore();
    dialogs.openDialog(Dialogs.UserLoginForm);
    router.replace(localePath(route.path));
  }
});
</script>
